import React, { Component } from "react";
import Header from "../header";
import Footer from "../footer";

import "../../style/base.scss";
import "../../style/base_mobile.scss";

import ReactPixel from "react-facebook-pixel";
ReactPixel.init("1252761548202229");
ReactPixel.pageView();

class App extends Component {
  render() {
    return (
      <div
        className={`aboss__body-container ${this.props.location.pathname
          .replace("/", "")
          .replace("/", "-")}`}
      >
        <Header location={this.props.location} />
        {this.props.children}
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// src/components/app/index.js